import { Skeleton } from "@/components/ui/skeleton";
import { useI18n } from "@/context/I18nContext";

const FLAGGED = ["LOCKDOWN", "VISITATION_SUSPENDED", "EMERGENCY", "LIMITED_VISITATION", "RESTRICTED"];

export const HomeStats = ({ facilities, jurisdictions, loading }) => {
  const { t } = useI18n();
  const stats = [
    ["stat-facilities", facilities.length, t("stats.facilities")],
    ["stat-federal", facilities.filter((f) => f.system_type === "federal").length, t("stats.federal")],
    ["stat-jurisdictions", jurisdictions, t("stats.jurisdictions")],
    ["stat-verified", facilities.filter((f) => f.status && f.status !== "UNKNOWN").length, t("stats.verified")],
    ["stat-flagged", facilities.filter((f) => FLAGGED.includes(f.status)).length, t("stats.flagged")],
  ];
  return (
    <section className="mx-auto max-w-6xl px-4 sm:px-6 pt-10 sm:pt-14" data-testid="home-stats-section">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-px overflow-hidden rounded-lg border border-slate-200 bg-slate-200">
        {stats.map(([tid, value, label]) => (
          <div key={tid} className="bg-white p-5" data-testid={tid}>
            {loading ? (
              <Skeleton className="h-8 w-16" />
            ) : (
              <div className="font-heading text-3xl font-extrabold text-slate-900 tabular-nums">{value.toLocaleString()}</div>
            )}
            <div className="mt-1 font-mono text-[11px] uppercase tracking-widest text-slate-500">{label}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export { FLAGGED };
